var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.organization?.id)?_c('user-list',{attrs:{"organization-id":_vm.organization.id}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }